export default __webpack_public_path__ + "static/media/DASHAM.000d0def.svg";